// extracted by mini-css-extract-plugin
export default {"TextField":"TextField_TextField__X+GFS","FieldLabel":"TextField_FieldLabel__RVaPE","Medium":"TextField_Medium__vFm8g","Big":"TextField_Big__6oVyr","Huge":"TextField_Huge__p-sLr"};